import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./services/store";
import "./styles/App.scss";

/** Layouts */
import Layout from "./layouts/layout";
import Inboxes from "./layouts/inboxes";

/** Pages */
import Home from "./pages/home";
import NotFound from "./pages/notfound";
import Help from "./pages/help";
import Signin from "./pages/signin";
import Match360 from "./pages/match360";
import Register from "./pages/register";
import Forgot from "./pages/forgot";
import Seek from "./pages/seek";
import Issues from "./pages/issues";
import Politics from "./pages/politics";
import Agreements from "./pages/agreements";
import Terms from "./pages/terms";

/** Integration */
import UserReport from "./integrations/userReport";
import FindReport from "./integrations/findReport";
import UsaOrder from "./integrations/usaOrder/usaOrder";

/** Projects */

/** Hackaton */
import HomeVoice from "./pages/homeVoice";

/** Views */
import ViewNotFound from "./views/viewNotfound";
import ViewDefault from "./views/viewDefault";
import ViewUsers from "./views/viewUsers";
import ViewContacts from "./views/viewContacts";
import ViewProfile from "./views/viewProfile";
import viewPreferences from "./views/viewPreferences";
import ViewDevToolBox from "./views/viewDevToolbox";
import ViewSuports from "./views/viewSuports";
import ViewLogs from "./views/viewLogs";
import ViewProjects from "./views/viewProjects";
/** Warehouse */
import ViewWarehouse from "./views/warehouse/viewWarehouse";
import ViewCellar from "./views/warehouse/viewCellar";
/** Keep */
import ViewKeep from "./views/keep/viewKeep";
import ViewEquipment from "./views/assets/viewEquipment";
import ViewMaps from "./views/keep/viewMaps";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Layout>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/help" component={Help} />
            <Route exact path="/signin" component={Signin} />
            <Route exact path="/match360" component={Match360} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/forgot" component={Forgot} />
            <Route exact path="/seek" component={Seek} />
            <Route exact path="/issues" component={Issues} />
            <Route exact path="/politics" component={Politics} />
            <Route exact path="/agreements" component={Agreements} />
            <Route exact path="/terms" component={Terms} />
            <Route exact path="/inboxes*">
              <Inboxes>
                <Switch>
                  <Route exact path="/inboxes" component={ViewDefault} />
                  <Route exact path="/inboxes/users" component={ViewUsers} />
                  <Route exact path="/inboxes/contacts" component={ViewContacts} />
                  <Route exact path="/inboxes/profile" component={ViewProfile} />
                  <Route exact path="/inboxes/preferences" component={viewPreferences} />
                  <Route exact path="/inboxes/devtoolbox" component={ViewDevToolBox} />
                  <Route exact path="/inboxes/suports" component={ViewSuports} />
                  <Route exact path="/inboxes/logs" component={ViewLogs} />
                  <Route exact path="/inboxes/projects" component={ViewProjects} />
                  <Route exact path="/inboxes/admin" component={ViewProjects} />
                  <Route exact path="/inboxes/warehouse" component={ViewWarehouse} />
                  <Route exact path="/inboxes/cellar" component={ViewCellar} />
                  <Route exact path="/inboxes/ilumina" component={ViewKeep} />
                  <Route exact path="/inboxes/redist" component={ViewKeep} />
                  <Route exact path="/inboxes/equipment" component={ViewEquipment} />
                  <Route exact path="/inboxes/maps" component={ViewMaps} />
                  <Route component={ViewNotFound} />
                </Switch>
              </Inboxes>
            </Route>
            <Route exact path="/userReport/*" component={UserReport} />
            <Route exact path="/findReport/*" component={FindReport} />
            <Route exact path="/usaorder/*" component={UsaOrder} />
            <Route exact path="/homevoice" component={HomeVoice} />
            <Route component={NotFound} />
          </Switch>
        </Layout>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
